import { enumify } from './enumify';

const numberFormatType = {
    DECIMAL_POINT_DOT: '0,000.00',
    DECIMAL_POINT_COMMA: '0.000,00'
};

export const NumberFormatType = enumify(numberFormatType);
export type NumberFormatType = keyof typeof numberFormatType;
